import { msalInstance, msalInitPromise, loginRequest } from "authConfig";

export class AuthClient {
    public async getToken(): Promise<string | undefined>
    { 
        try {
            await msalInitPromise;
            const { idToken } = await msalInstance.acquireTokenSilent({ forceRefresh: true, scopes: loginRequest.scopes });
            return idToken;
        } catch (e) {
            console.log(e);
        }
    }
}